import EnhancedForm from '@runway/enhanced-form';
import debounce from '@runway/util-debounce';
import { send } from '@runway/util-ajax';

export const name = 'form-custom-enroll-personal';

export default class FormCustomEnrollPersonal extends EnhancedForm {
    get name() {
        return name;
    }

    constructor(node) {
        super(node);

        this.emailAddressInputSelector = '#personal_details_email';
        this.existingAccountNotificationEl = this.node.querySelector('#email-address-notification__existing-account');
        this.nonExistingAccountNotificationEl = this.node
            .querySelector('#email-address-notification__non-existing-account');
        this.emailAddressInput = this.node.querySelector('#personal_details_email');
        this.phoneNumberEl = this.node.querySelector('[data-custom-validated="phone-numbers"]');
        this.phoneNumberInputs = this.phoneNumberEl.querySelectorAll('[data-component="rw-input-element"]');

        this.phoneNumberInstances = [...this.phoneNumberInputs].map(
            inputNode => window.SHG.retrieveInstanceFromNode(inputNode)
        );

        this.setupEventListeners();
    }

    submit(event) {
        // Disabled input fields can't be submitted to the back-end so we need to remove the attribute here
        this.node.querySelector(this.emailAddressInputSelector).removeAttribute('disabled');
        super.submit(event);
    }

    isValidForm() {
        this.cleanCustomErrors(this.phoneNumberInstances);

        const valid = super.isValidForm(false);

        const customFieldsValid = this.validatePhoneNumbers();

        return valid && customFieldsValid;
    }

    setupEventListeners() {
        const phoneNumberSelector = '[name*="personalNumber"],[name*="businessNumber"]';
        const debouncedPhoneInputBlurHandler = debounce(e => this.handlePhoneNumberInputBlur(e), 0);
        const debouncedEmailCheckHandler = debounce(e => this.checkForEmailAddressExistence(e), 0);

        this.subscribe(`dom:${phoneNumberSelector}:input`, e => this.handlePhoneNumberInputChange(e));
        this.subscribe(`dom:${phoneNumberSelector}:blur`, debouncedPhoneInputBlurHandler);
        this.subscribe(`dom:${this.emailAddressInputSelector}:blur`, debouncedEmailCheckHandler);
    }

    isValidEmailAddress() {
        return this.emailAddressInput.checkValidity();
    }

    validatePhoneNumbers() {
        let submittedPhoneNumbers = 0;
        let inputsAreValid = true;

        this.phoneNumberInstances.forEach(instance => {
            if (instance.inputNode.value.length) {
                submittedPhoneNumbers += 1;
            }

            if (!instance.validate()) {
                inputsAreValid = false;
            }
        });

        if (submittedPhoneNumbers <= 0) {
            this.showCustomErrors(this.phoneNumberInstances, this.phoneNumberEl.dataset.message_required);
            this.customPhoneErrorShown = true;
        }

        return submittedPhoneNumbers > 0 && inputsAreValid;
    }

    cleanCustomErrors(instances) {
        instances.forEach(instance => instance.cleanError());
    }

    showCustomErrors(instances, errorMessage) {
        instances.forEach(instance => instance.showError(errorMessage));
    }

    toggleNotificationMessages(accountExists) {
        if (accountExists) {
            this.existingAccountNotificationEl.removeAttribute('hidden');
            this.nonExistingAccountNotificationEl.setAttribute('hidden', null);
        } else {
            this.existingAccountNotificationEl.setAttribute('hidden', null);
            this.nonExistingAccountNotificationEl.removeAttribute('hidden');
        }
    }

    async checkForEmailAddressExistence(event) {
        event.stopPropagation();

        const email = event.target.value;

        if (!email || !this.isValidEmailAddress()) {
            return;
        }

        try {
            await send(`/account/api/v1/accounts/${email}`, {
                method: 'HEAD'
            });

            this.toggleNotificationMessages(true);
        } catch (error) {
            this.toggleNotificationMessages(false);
        }
    }

    handlePhoneNumberInputChange(e) {
        if (this.customPhoneErrorShown) {
            this.customPhoneErrorShown = false;
            this.cleanCustomErrors(this.phoneNumberInstances);
        }

        if (e.target.value.length === 0) {
            this.validatePhoneNumbers();
        }
    }

    handlePhoneNumberInputBlur() {
        this.validatePhoneNumbers();
    }
}
